import React, { useState, useEffect } from "react";
import DashboardSidebarMenu from "../../components/controls/DashboardSideBarMenu";
import { getProviderMenus } from "../../contexts/ProviderMenus";
import { useTranslation } from "react-i18next";
import ServiceModal from "./ServicesModal";
import ServiceCard from "../../components/controls/ServiceCard";
import { PlusIcon } from "@heroicons/react/24/solid";
import { getServicesWithAvailabilities } from "../../db/Services";
import { useAuth } from "../../contexts/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import ProductCard from "../../components/controls/ProductCard";
import {
  fetchCompaniesByUserId,
  getServicesByCompanyId,
} from "../../db/Companies";

const ServicesList = () => {
  const { currentUser } = useAuth();
  const userId = currentUser?.id;
  const { t } = useTranslation();
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const menus = getProviderMenus();
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  useEffect(() => {
    const loadCompanies = async () => {
      try {
        const data = await fetchCompaniesByUserId(userId);
        setCompanies(data);
        if (data.length > 0) setSelectedCompanyId(data[0].id);
      } catch (err) {
        console.error("Erreur lors du chargement des compagnies :", err);
      }
    };
    if (userId) loadCompanies();
  }, [userId]);

  useEffect(() => {
    const loadServices = async () => {
      if (!selectedCompanyId) return;
      try {
        setLoading(true);
        const data = await getServicesByCompanyId(selectedCompanyId);
        setServices(data);
      } catch (err) {
        console.error("Erreur lors du chargement des services :", err);
        setError("Une erreur est survenue lors du chargement des services.");
      } finally {
        setLoading(false);
      }
    };
    loadServices();
  }, [selectedCompanyId]);

  const openEditModal = (data) => {
    navigate(`/provider-dashboard/services/${data.id}`);
    /*setSelectedRowData(data);
    setIsModalOpen(true);*/
  };

  const openAddModal = () => {
    navigate("/provider-dashboard/services/new?companyId=" + selectedCompanyId);
    /*setSelectedRowData(null);
    setIsModalOpen(true);*/
  };

  const closeModal = () => {
    setSelectedRowData(null);
    setIsModalOpen(false);
  };

  const saveService = (serviceData) => {
    setServices((prev) => {
      if (prev.some((item) => item.id === serviceData.id)) {
        return prev.map((item) =>
          item.id === serviceData.id ? { ...item, ...serviceData } : item
        );
      }
      return [...prev, serviceData];
    });

    closeModal();
  };

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  return (
    <div className="flex text-primary">
      {/* Sidebar */}
      <DashboardSidebarMenu title={t("admin.title")} menus={menus} />

      {/* Main Content */}
      <div className="flex-grow">
        <div className="container mx-auto px-6 py-8">
          <h1 className="text-2xl font-bold mb-4 mx-4 text-onWhite">
            {t("services.myServices")}
          </h1>
          <div className="w-full max-w-sm mb-6 mx-4">
            <label className="block text-sm font-medium text-onWhite mb-1">
              {t("products.selectCompany")}
            </label>
            <select
              className="select select-bordered w-full bg-base-100 text-onWhite focus:outline-none focus:ring-2 focus:ring-primary"
              value={selectedCompanyId || ""}
              onChange={(e) => setSelectedCompanyId(e.target.value)}
            >
              {companies.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              ))}
            </select>
          </div>

          <div
            className="mb-4 bg-primary px-4 py-2 rounded-full mx-4 inline-flex items-center space-x-2 hover:cursor-pointer"
            onClick={openAddModal}
          >
            <PlusIcon className="w-6 h-6 text-white" />
            <button type="submit" className="text-white">
              {t("modal.addService")}
            </button>
          </div>

          {services.length === 0 ? (
            <p className="mx-4 text-gray-500 italic">
              {t("services.noServiceForCompany") ||
                "Aucun service pour cette compagnie."}
            </p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {services.map((service) => (
                <ProductCard
                  key={service.id}
                  product={service}
                  openEditModal={() => openEditModal(service)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServicesList;
